import { render } from "./RelatedVolumeSnapshotCounts.vue?vue&type=template&id=90c2d3da"
import script from "./RelatedVolumeSnapshotCounts.vue?vue&type=script&lang=js"
export * from "./RelatedVolumeSnapshotCounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__